<template>
    <SectionViewLayout
      :title="'settings.identities.titles.' + titles[route.name]"
      :content_state="content_state"
      content_class="identities-form"
      close_class="close"
      close_route="identities-list"
    >
        <template #actions>
            <ActionButton
                @click='onActionSave()'
                v-tooltip='"global.actions.save"'
                icon="fas fa-save"
                :disabled="content_state.saving"
            />
        </template>

        <template #content>
            <form>
                <fieldset>
                    <InputText
                      :ref="refs.id"
                      input_id="identityId"
                      input_name="id"
                      :input_required="true"
                      :input_invalids="properties_validation.invalid"
                      label_text="settings.identities.labels.id"
                      error_text="settings.identities.labels.invalid_id"
                      v-model:input_value="identity.id"
                      :input_focus="true"
                      @change="properties_validation.validateField('id', identity.id)"
                    />

                    <InputText
                      input_id="identityName"
                      label_text="settings.identities.labels.name"
                      input_name="name"
                      v-model:input_value="identity.name"
                    />

                    <InputSelect
                      :ref="refs.contact_boxes"
                      input_id="identityEmail"
                      label_text="settings.identities.labels.email"
                      input_name="email"
                      :input_required="true"
                      v-model:input_value="identity.email"
                      :disabled="identity.is_alias === false"
                      :options="selectable_alias">
                    </InputSelect>
                    <div class="control-group">
                        <div class="control" :ref="refs.contact_boxes">
                            <label for="bbcAddrDesc">{{Language.say('settings.identities.labels.bcc')}}</label>

                            <div class="append-button">
                                <ContactsInputBoxes
                                    ref="contact_boxes_element"
                                    :contacts_controller="contacts_controller"
                                    :contacts_boxes_collection="contacts_cc_collection"
                                >
                                </ContactsInputBoxes>

                                <ActionButton
                                    @click="onContactsModalOpen()"
                                    v-tooltip='"settings.identities.select_contacts"'
                                    class="clear"
                                    icon='far fa-user'
                                />

                            </div>
                        </div>
                    </div>
                    <div class="control-group">
                        <div class="control">
                            <label for="signature_html">{{Language.say('settings.identities.labels.signature')}}</label>
                            <div class="editor-group">
                                <HTMLEditor
                                  ref="html_editor"
                                  inline_upload_type="single"
                                  :image_size_limit="config.image_size_limit"
                                />
                            </div>
                        </div>
                    </div>
                    <InputCheckbox
                      input_id="IdentiyDefaultCheck"
                      label_text="settings.identities.set_default"
                      input_name="default"
                      :disabled="props.identities_controller.identities.count === 1 && route.name === 'identities-edit'"
                      v-model:input_value="identity.default">
                    </InputCheckbox>
                </fieldset>
                <div class="submit-desktop">
                    <ActionButton
                        v-if="can_be_deleted === true"
                        class="main-action "
                        icon="fas fa-trash-alt"
                        text="settings.identities.actions.delete"
                        @click="onActionDelete()"
                        :disabled="identity.default"
                        :loading="content_state.saving"
                    />
                    <ActionButton
                        @click='onActionSave()'
                        class="main-action"
                        icon="fas fa-save"
                        text="global.actions.save"
                        :loading="content_state.saving"
                    />
                </div>
            </form>

            <ConfirmModal v-if="delete_warning_visible"
                title='settings.identities.titles.delete_warning'
                :content_state="content_state"
                @actionCancel='onActionDeleteCancel()'
                @actionConfirm="onActionDeleteConfirm()"
                confirm_class="danger"
            >
                <template #modal_body>
                    <p>{{Language.say('settings.identities.delete_warning')}}</p>
                    <p>{{Language.say('settings.identities.not_reversible')}}</p>
                </template>
            </ConfirmModal>

            <ContactsSelectModal v-if="contacts_modal_visible"
                @contactsSelectModalCancel="onContactsModalCancel"
                @contactsSelectModalSubmit="onContactsModalSubmit"
                :contacts_controller="contacts_controller"
                :selected_contacts="contacts_cc_collection"
                >
            </ContactsSelectModal>
        </template>
    </SectionViewLayout>
</template>

<script setup>
  import { ref, reactive, nextTick }  from 'vue';
  import { onBeforeMount, }           from 'vue';
  import { defineProps, }             from 'vue';
  import { useRouter,useRoute }       from 'vue-router';
  import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue';
  import HTMLEditor                   from '@/vue/Elements/Tools/HTMLEditor/HTMLEditor.vue';
  import InputSelect                  from '@/vue/Elements/Inputs/InputSelect.vue';
  import InputCheckbox                from '@/vue/Elements/Inputs/InputCheckbox.vue';
  import InputText                    from '@/vue/Elements/Inputs/InputText.vue';
  import SectionViewLayout            from '@/vue/Layouts/Sections/SectionViewLayout.vue';
  import ContactsSelectModal          from '@/vue/Views/Contacts/Modals/ContactsSelectModal.vue';
  import ContactsInputBoxes           from '@/vue/Views/Contacts/Partials/ContactsInputBoxes.vue';
  import ConfirmModal                 from '@/vue/Views/Webmail/Modals/ConfirmModal.vue';
  import AccountControler             from '@/js/Webmail/AccountController.js'
  import PropertiesValidation         from '@/js/Shared/Validation/PropertiesValidation.js'
  import Language                     from '@/js/Shared/Language/Language.js';
  import ContactsBoxesCollection      from '@/js/Contacts/Collections/ContactsBoxesCollection.js';
  import SAPOMailConfig               from '@/SAPOMailConfig';

  const props = defineProps({
    identities_controller : {},
    contacts_controller   : {},
    content_state         : {},
   })

  const route                  = useRoute();
  const router                 = useRouter();
  const contacts_cc_collection = reactive(new ContactsBoxesCollection());
  const html_editor            = ref();
  const selectable_alias       = ref([]);
  const contacts_modal_visible = ref(false);
  const delete_warning_visible = ref(false);
  const contact_boxes_element  = ref();
  const identity               = ref();
  const can_be_deleted         = ref(false);
  const config                 = SAPOMailConfig.client.settings.signature;

  const properties_validation  = reactive(new PropertiesValidation({
    id : {
      required : true
    },
  }));

  const titles      = {
    'identities-add' : 'add',
    'identities-edit': 'edit',
  }

  const refs = {
    'id' : ref(),
    'email' : ref(),
    'contact_boxes' : ref(),
  }

  onBeforeMount(() => {
    props.content_state.onLoaded(async () => {
      setIdentity();
      setSelectableAlias();
      setCanBeDeleted();
      setIdentityDefaultEmail();
      contacts_cc_collection.setContacts(props.contacts_controller.contacts);

      if (identity.value.bccs.length) {
        contacts_cc_collection.addPersonsByArray(identity.value.bccs);
      }

      await nextTick();
      if (identity.value.signature_html) {
        html_editor.value.editor.setContents(identity.value.signature_html);
      }
    })
  });

  const onContactsModalOpen = () => {
    setContactsModalVisibility(true);
  }

  const onContactsModalCancel = () => {
    setContactsModalVisibility(false);
  }

  const onContactsModalSubmit = (contacts) => {
    contacts_cc_collection.reset();
    contacts_cc_collection.addItems(contacts.items);
    setContactsModalVisibility(false);
  }

  const onActionSave = async () => {
    contact_boxes_element.value.forceInput();

    if (await saveIdentity() === false) {
      return;
    }

    close();
  }

  const onActionDelete = () => {
    setDeleteWarningVisibility(true);
  }

  const onActionDeleteConfirm = async () => {
    if (await deleteIdentity() === false) {
      return;
    }

    setDeleteWarningVisibility(true);
    close()
  }

  const onActionDeleteCancel = () => {
    setDeleteWarningVisibility(false);
  }

  const onActionClose = () => {
    close();
  }

  const setIdentity = () => {
    identity.value = props.identities_controller.identities.getClone(route.params.id || null);
  }

  const setCanBeDeleted = () => {
    if (route.name === 'identities-add') {
      can_be_deleted.value = false;
      return;
    }

    if (props.identities_controller.identities.count === 1) {
      can_be_deleted.value = false;
      return;
    }

    can_be_deleted.value = true;
  }

  const setIdentityDefaultEmail = () => {
    if (route.name === 'identities-edit') {
      return;
    }

    identity.value.email = selectable_alias.value[0];
  }

  const setSelectableAlias = () => {
    if (identity.value.is_alias === false) {
      selectable_alias.value = [identity.value.email];
      return;
    }

    selectable_alias.value = AccountControler.getAlias();
  }

  const setContactsModalVisibility = (visibility) => {
    contacts_modal_visible.value = visibility
  }

  const setDeleteWarningVisibility = (visibility) => {
    delete_warning_visible.value = visibility
  }

  const saveIdentity = async () => {
    let contacts = contact_boxes_element.value.getContacts();

    if (properties_validation.validateObject(identity.value) === false) {
      scrollIntoRef(properties_validation.getFirstInvalid());
      return false;
    }

    if (contacts.validEmails() === false) {
      scrollIntoRef('contact_boxes');
      return false;
    }

    identity.value.bccs           = contacts.getEmailsAsString();
    identity.value.signature_html = html_editor.value.editor.getContents();

    props.content_state.setSaving(true);
    let success = await props.identities_controller.saveIdentity(identity.value);
    props.content_state.setSaving(false);
    return success;
  }

  const deleteIdentity = async () => {
    props.content_state.setSavingInline(true);
    let success = await props.identities_controller.deleteIdentity(identity.value);
    props.content_state.setSavingInline(false);
    return success;
  }

  const scrollIntoRef = (id_ref) => {
    let $element = refs[id_ref].value.$el || refs[id_ref].value;

    $element.scrollIntoView({block: "end", behavior: "smooth"});
  }

  const close = () => {
    router.push('/settings/identities');
  }
</script>